import React from 'react'
import PropTypes from 'prop-types'
import Text from '../Text/Text'
import styles from './errorMessages.module.scss'

const ErrorMessages = (props) => {
  const { error } = props

  if (!error.hasError) return null

  return (
    <div className={styles.errorMessages}>
      {error?.messages.map((message) => (
        <Text key={message} size="xxxs" lineHeight="12px" color="error" bold>
          {message}
        </Text>
      ))}
    </div>
  )
}

ErrorMessages.defaultProps = {
  error: {
    hasError: false,
    messages: []
  }
}

ErrorMessages.propTypes = {
  error: PropTypes.shape({
    hasError: PropTypes.bool,
    messages: PropTypes.arrayOf(PropTypes.string)
  })
}

export default ErrorMessages
